/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css } from 'aphrodite/no-important';
import { fonts, mixins, variables } from '@blend/consumer-components';
import { GenerateStyles, useConsumerTheme } from '../../hooks/useConsumerTheme';

export type TagType = 'info' | 'affirm' | 'void' | 'error' | 'warn';

export namespace Tag {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {
    type?: TagType;
  }
}

const generateStyles: GenerateStyles = ({ colors }) => ({
  tag: {
    ...mixins.borderRadius(variables.globalBorderRadiusHalf),
    ...mixins.padding(2, 4),
    ...fonts.UntitledSans,
    fontSize: 10,
    fontWeight: fonts.weight.bold,
    lineHeight: '12px',
    position: 'relative',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
  },
  info: {
    color: colors.reflex,
    background: colors.reflexLight08,
  },
  warn: {
    color: colors.orange,
    background: colors.paleYellow,
  },
  error: {
    color: colors.brickPlus2,
    background: colors.brickMinus10,
  },
  affirm: {
    color: colors.catalyst,
    background: colors.catalystLight03,
  },
  void: {
    color: colors.pinkDark33,
    background: colors.pinkLight08,
  },
});

export const Tag: React.FC<Tag.Props> = ({ children, type = 'info', ...htmlProps }) => {
  const { styles } = useConsumerTheme(generateStyles);

  return (
    <span className={css(styles.tag, styles[type])} {...htmlProps}>
      {children}
    </span>
  );
};
